import mapValuesForSubmit from './mapValuesForSubmit';
import CompanyService from 'App/services/CompanyService';
import { queryClient } from 'Shared/queryClient';

function updateUser(values) {
    const user = mapValuesForSubmit(values);

    return CompanyService.updateCompanyUser(values.id, user).then(() => {
        queryClient.removeQueries(['company', 'users']);
    });
}

export default updateUser;
